// extracted by mini-css-extract-plugin
export default {"markdownChatAIBlock":"ChatAI_markdownChatAIBlock__pYKAn","markdownBlock":"ChatAI_markdownBlock__tP8ec"};